import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, createTheme, IconButton, ThemeProvider } from '@mui/material';
import { useTranslation } from 'react-i18next';

const theme = createTheme({
  palette: {
    dark_yellow: {
      "main": "#393D44",
      "light": "#393D44",
      "dark": "#393D44",
      "contrastText": "#FAEF9B",
    },
    dark_white: {
      "main": "#393D44",
      "light": "#393D44",
      "dark": "#393D44",
      "contrastText": "#FFFFFF",
    },
    dark: {
      "main": "#393D44",
      "light": "#393D44",
      "dark": "#393D44",
      "contrastText": "#393D44"
    }
  },
});
const Nav = ({ page }) => {

  const { t } = useTranslation('nav');

  const isPassed = (currentPage, targetPage) => {
    const order = ["service", "therapist", "payment"];
    return order.indexOf(currentPage) > order.indexOf(targetPage);
  };

  const isCurrentOrPassed = (currentPage, targetPage) => {
    const order = ["service", "therapist", "payment"];
    return order.indexOf(currentPage) >= order.indexOf(targetPage);
  };

  const navigate = useNavigate();
  const goBack = () => [navigate(-1)];

  const handleNav = (current, target) => {
    if (current === target) {
      return;
    }
    const currentState = JSON.parse(sessionStorage.getItem('state') || {});
    switch (target) {
      case "service":
        navigate('/hotel-choose-service', { state: currentState });
        break;
      case "therapist":
        navigate('/hotel-choose-therapist', { state: currentState });
        break;
      case "payment":
        navigate('/hotel-payment', { state: currentState });
        break;
      default:
        navigate('/hotel-choose-service', { state: currentState });
        break;
    }
  };

  return (
    <div className="menu-nav">
      <ThemeProvider theme={theme}>
        <Button
          variant="text"
          color="dark"
          sx={{ textTransform: 'none', fontSize: '20px', gap: '10px' }}
          onClick={goBack}
        >
          <img src='assets/images/icon-back.svg' /> {t('nav:back')}
        </Button>
      </ThemeProvider>
      <ul>
        {["service", "therapist", "payment"].map((step, index) => (
          <li key={index}>
            <ThemeProvider theme={theme}>
              <Button
                variant={!isCurrentOrPassed(page, step) ? 'outlined' : 'contained'}
                color={isPassed(page, step) ? 'dark_white' : !isCurrentOrPassed(page, step) ? 'dark' : 'dark_yellow'}
                sx={{ borderRadius: '50px', gap: '5px', opacity: isPassed(page, step) ? 0.5 : 1, textTransform: 'none' }}
                disabled={!isCurrentOrPassed(page, step)}
                onClick={() => handleNav(page, step)}
              >
                {
                  step === "service" ? t('nav:choose_service') :
                    step === "therapist" ? t('nav:choose_therapist') : t('nav:payment')}
                {isCurrentOrPassed(page, step) && !isPassed(page, step) ? (<img src='assets/images/icon-next-yellow.svg' />) : (isPassed(page, step) ? (<img src='assets/images/icon-check.svg' />) : (<></>))}
              </Button>
            </ThemeProvider>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Nav;
